import { useQuery, useMutation } from '@tanstack/react-query'
import {
  getCapabilities,
  submitImport,
  uploadImport,
  getImportJob,
  indexImportJob,
  getSagaStatus,
} from '../services/importApi'

const TERMINAL = new Set(['completed', 'failed', 'cancelled', 'already_transcribed'])
const SAGA_TERMINAL = new Set(['completed', 'failed', 'compensated', 'cancelled'])

export function useCapabilities(input, source) {
  return useQuery({
    queryKey: ['import', 'cap', input, source],
    queryFn: () => getCapabilities(input, source),
    enabled: !!(input || source),
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
}

export const useSubmitImport = () => useMutation({ mutationFn: submitImport })

export const useUploadImport = () => useMutation({ mutationFn: uploadImport })

// Polls until the job reaches a terminal state.
export function useImportJob(jobId) {
  return useQuery({
    queryKey: ['import', 'job', jobId],
    queryFn: () => getImportJob(jobId),
    enabled: !!jobId,
    refetchInterval: (query) => (TERMINAL.has(query.state.data?.status) ? false : 2000),
  })
}

export const useIndexJob = () => useMutation({ mutationFn: indexImportJob })

// Polls a saga until it settles (the durable poll→index tail of an import).
export function useSaga(sagaId) {
  return useQuery({
    queryKey: ['saga', sagaId],
    queryFn: () => getSagaStatus(sagaId),
    enabled: !!sagaId,
    refetchInterval: (query) => (SAGA_TERMINAL.has(query.state.data?.status) ? false : 2000),
  })
}

export { TERMINAL, SAGA_TERMINAL }
